export const deleteAppointment = (appointmentId, notify, deleteSoftHold, isServiceDeleted) => {
    return JSON.stringify({
        query: `mutation($appointmentId: UUID!, $deleteSoftHold: Boolean, $notify: Boolean, $isServiceDeleted: Boolean){
        deleteAppointmentsMutation(appointmentId:$appointmentId, deleteSoftHold: $deleteSoftHold, notify: $notify, isServiceDeleted: $isServiceDeleted){
          message
        }
      }`,
        variables: {"appointmentId": String(appointmentId), "deleteSoftHold": Boolean(deleteSoftHold), "notify": Boolean(notify), "isServiceDeleted": Boolean(isServiceDeleted)}
      })
};